module.exports = __webpack_public_path__ + "static/media/diogo_santos.ad366687.jpg";